import { lazy } from 'react';

const MaterialSaleRecordsAdminConfig = {
	settings: {
		layout: {
			config: { footer: { display: false } }
		}
	},
	routes: [
		{
			path: '/adm/consult/material-sale-records',
			component: lazy(() => import('./MaterialSaleRecordsContainer'))
		}
	]
};

export default MaterialSaleRecordsAdminConfig;
